import isUndefined from 'lodash/isUndefined'
import { FC } from 'react'

import type { Config } from '~/form/types'

type Props = {
  isConfirm: boolean
  configs?: Config[]
}

const FormField: FC<Props> = ({ configs, isConfirm }) => {
  if (isUndefined(configs)) return null

  return (
    <>
      {configs.map((config, index) => {
        const Component = config.component

        return <Component key={index} isConfirm={isConfirm} {...config.props} />
      })}
    </>
  )
}

export default FormField
